import SwipeableTabs from "./src/SwipeableTabs"
export default SwipeableTabs